
<template>
  <v-dialog
    v-model="dialog"
    scrollable
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <v-toolbar dark color="primary" max-height="60">
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>
          <v-icon>mdi-card-text</v-icon>
          {{ $i18n.t("Load Board") }}
        </v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <loads
          @closeDialog="closeDialog"
          :corpType="corpType"
          :shouldReload="dialog"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import Loads from "@/views/load/Loads.vue";

@Component({
  name: "EntityCreate",
  components: {
    Loads,
  },
  props: {
    showDialog: {
      default: false,
    },
    corpType: {
      default: null,
    },
  },
})
export default class LoadBoard extends Vue {
  dialog = false;

  hideMe() {
    this.$emit("dialogUpdate", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.dialog = val;
  }

  closeDialog() {
    this.dialog = false;
    this.$emit("close", null);
  }
}
</script>
